module.exports = __webpack_public_path__ + "static/media/YF71_1.52815870.jpg";